import React from 'react';
import TitleMasterPage from './TitleMasterPage';
import {
  createMasterPlantCode,
  deleteMasterPlantCode,
  getMasterPlantCodes,
  updateMasterPlantCode,
} from '../../../services/masterPlantCodeService';

const PlantCodes: React.FC = () => (
  <TitleMasterPage
    heading="Plant Codes"
    singular="Plant Code"
    loadItems={getMasterPlantCodes}
    createItem={createMasterPlantCode}
    updateItem={updateMasterPlantCode}
    deleteItem={deleteMasterPlantCode}
  />
);
export default PlantCodes;
